'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.changeConfirmLocale = changeConfirmLocale;
exports.getConfirmLocale = getConfirmLocale;
var defaultLocale = {
  okText: '确定',
  cancelText: '取消',
  justOkText: '知道了'
};

var runtimeLocale = _extends({}, defaultLocale);

function changeConfirmLocale(newLocale) {
  if (newLocale) {
    runtimeLocale = _extends({}, runtimeLocale, newLocale);
  } else {
    runtimeLocale = _extends({}, defaultLocale);
  }
}

function getConfirmLocale() {
  return runtimeLocale;
}


/*****************
 ** WEBPACK FOOTER
 ** ./components/modal/locale.js
 ** module id = 68
 ** module chunks = 0
 **/